import {
  Flex,
  IconDownload,
  PrimaryButton,
  Typography,
} from '@banhala/ui-kit';
import { localizeNumber } from 'shared/src/utils';

type Props = {
  potentialPrice: number;
  loading?: boolean;
  onPressRedeem: () => void;
};

export const MaxDiscountPreviewRow = (props: Props) => {
  return (
    <Flex backgroundColor={'pink5'} padding={{ horizontal: 16, vertical: 12 }}>
      <Flex.Row alignItems={'center'} justifyContent={'space-between'}>
        <Flex.Row alignItems={'center'} gap={8}>
          <Typography type={'subtitle2'} color={'content_pink_primary'}>
            최대 할인 쿠폰 적용 시
          </Typography>
          <PrimaryButton
            color={'pink'}
            outline
            size={'xsmall'}
            variant={'fill'}
            leftIcon={<IconDownload width={16} height={16} />}
            isUseOriginalIconSize
            onPress={props.onPressRedeem}
            state={props.loading ? 'loading' : undefined}
          >
            받기
          </PrimaryButton>
        </Flex.Row>
        <Typography type={'h4'} color={'content_pink_primary'}>
          {localizeNumber(props.potentialPrice)}원
        </Typography>
      </Flex.Row>
    </Flex>
  );
};
